import AreasSectionContainer from "./AreasSectionContainer";
export default AreasSectionContainer;
